"use client";

import useIsClient from "@/hooks/useIsClient";
import { useEffect } from "react";

const HomePageScroll = () => {
  const isClient = useIsClient();
  const restoreScrollPosition = () => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
      sessionStorage.removeItem("scrollPosition");
    }
  };

  useEffect(() => {
    if (isClient) restoreScrollPosition();
  }, [isClient]);
  if (!isClient) return;
  return <></>;
};

export default HomePageScroll;
